import axios, { AxiosError } from "axios";
const DashboardResource = {
    loadDeliveriesByVehicleType(date, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/dashboard/deliveries-by-vehicle-type/${date}`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    }
};
export default DashboardResource;
